import { QueryParameters as BrandSearchParameters } from "@faire/web-api--source/endpoints/www/api/v2/search/brands/get";

const FULL_LOGGED_OUT_PAGE_SIZE = 60; // 60 items per page (10 rows)

const NUM_PRODUCT_IMAGES = 0;

export const brandsSearchRequest = ({
  navigationPath,
  filterKeys,
  oneIndexedPageNumber,
}: {
  navigationPath: string;
  filterKeys: string[];
  oneIndexedPageNumber: number;
}): BrandSearchParameters =>
  BrandSearchParameters.build({
    navigation_path: navigationPath,
    filter_keys: filterKeys,
    page: oneIndexedPageNumber,
    page_size: FULL_LOGGED_OUT_PAGE_SIZE,
    container_name: "marketplace_maker_grid",
    include_product_names: true,
    num_product_images: NUM_PRODUCT_IMAGES,
  });
